export interface Domain {
  readonly id: string;
  readonly num: string;
  readonly type: number;
  readonly numNo: number;
  readonly ddoNum: number;
  readonly ddoDdoNum: number;
  readonly libelle: string;
  readonly codeType: string;
  readonly leaf: boolean;
  readonly children: Domain[];
}

export enum GroupCodeTypeEnumeration {
  BUSINESS = 'M',
  CUSTOMER_RELATIONSHIP = 'R',
  ALERT = 'A',
  THINK_ABOUT = 'P',
  USEFUL_LINK = 'S',
  FILE = 'F',
}
